import axios from 'axios';

const GET_LIBRARY_ITEMS = 'v3/front/library/items';
const GET_LIBRARY_FILTER_OPTIONS = 'v3/front/library/items/filters';
const ADD_RESOURCE_TO_TEACHER_LIBRARY = 'v3/front/library/:userGuid/items/link';
const DELETE_RESOURCE_FROM_TEACHER_LIBRARY = 'v3/front/library/:userGuid/items';
const GET_TEACHER_LIBRARY_ITEMS = 'v3/front/library/:user_id/items';
const ADD_CONTENT_TO_TEACHER_LIBRARY = 'v3/front/library/:user_id/items';
const GET_TEACHER_LIBRARY_FOLDERS = 'v3/front/library/:user_id/folders';
const CREATE_TEACHER_LIBRARY_FOLDER = 'v3/front/library/:user_id/folders';
const UPDATE_TEACHER_LIBRARY_FOLDER = 'v3/front/library/:user_id/folders/:id';
const MOVE_CONTENT_TO_TEACHER_LIBRARY_FOLDER = 'v3/front/library/:user_id/items/:id';
const ADD_RESOURCE_TO_GENERAL_LIBRARY = 'v3/front/library/items/link';
const SHARE_CONTENT_WITH_PROGRAMS = 'v3/courses/:ref_course_id/contents/:content_id/resources';
const UNSHARE_CONTENT_WITH_PROGRAMS = 'v3/courses/:ref_course_id/contents/:content_id/resources/:resource_id';

export async function getGeneralContentLibrary(params) {
  return axios.get(GET_LIBRARY_ITEMS, { params });
}

export async function getGeneralLibraryFilterOptions(params) {
  return axios.get(GET_LIBRARY_FILTER_OPTIONS, { params });
}

export async function addResourceToTeacherLibrary(userGuid, resourceId) {
  return axios.put(ADD_RESOURCE_TO_TEACHER_LIBRARY.replace(':userGuid', userGuid), {
    libraryItemId: resourceId,
  });
}

export async function removeResourceFromTeacherLibrary(userGuid, resourceId) {
  return axios.delete(DELETE_RESOURCE_FROM_TEACHER_LIBRARY.replace(':userGuid', userGuid), {
    data: {
      library_teacher_item_id: resourceId, //array
    },
  });
}

export async function getTeacherLibraryItems(params, userGuid) {
  //TODO: Obtener items de la biblioteca del profesor
  //front/library/:user_id/items?page=:page&page_size=:page_size&search=:search
  return axios.get(GET_TEACHER_LIBRARY_ITEMS.replace(':user_id', userGuid), { params });
}

export async function addContentToTeacherLibrary(userId, contentGuid) {
  return axios.post(ADD_CONTENT_TO_TEACHER_LIBRARY.replace(':user_id', userId), {
    content_guid: contentGuid,
  });
}

export async function createTeacherLibraryFolder(userId, folderName) {
  return axios.post(CREATE_TEACHER_LIBRARY_FOLDER.replace(':user_id', userId), {
    name: folderName,
  });
}

export async function getTeacherLibraryFolders(params, userGuid) {
  return axios.get(GET_TEACHER_LIBRARY_FOLDERS.replace(':user_id', userGuid), { params });
}

export async function editTeacherLibraryFolder(userId, folderId, folderName) {
  return axios.put(UPDATE_TEACHER_LIBRARY_FOLDER.replace(':user_id', userId).replace(':id', folderId), {
    name: folderName,
  });
}

export async function addContentToTeacherLibraryFolder(userId, folderId, contentId) {
  return axios.put(MOVE_CONTENT_TO_TEACHER_LIBRARY_FOLDER.replace(':user_id', userId).replace(':id', contentId), {
    folderId: folderId,
  });
}

export async function removeContentFromTeacherLibraryFolder(userId, contentId) {
  return axios.put(MOVE_CONTENT_TO_TEACHER_LIBRARY_FOLDER.replace(':user_id', userId).replace(':id', contentId), {
    folderId: null,
  });
}

export async function addResourceToGeneralLibrary(resourceId, schoolId) {
  return axios.put(ADD_RESOURCE_TO_GENERAL_LIBRARY, {
    library_teacher_item_id: resourceId,
    school_id: schoolId,
  });
}

export async function shareContentWithPrograms(courseId, contentId) {
  return axios.post(SHARE_CONTENT_WITH_PROGRAMS.replace(':ref_course_id', courseId).replace(':content_id', contentId), {
    section: 'annual',
  });
}

export async function unshareContentWithPrograms(courseId, contentId, resourceId) {
  return axios.delete(UNSHARE_CONTENT_WITH_PROGRAMS.replace(':ref_course_id', courseId).replace(':content_id', contentId).replace(':resource_id', resourceId));
}
